const R = 6371;
const rad = (d) => (d * Math.PI) / 180;

export const distanceKm = (a, b) => {
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
};

export const nearest = (items, me) =>
  items.filter((p) => p.lat != null && p.lng != null)
    .reduce((best, p) => (!best || distanceKm(me, p) < distanceKm(me, best) ? p : best), null);

export const locate = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) {
    reject(new Error("unsupported"));
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
    reject,
    { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 },
  );
});
